import { React, useState, useEffect, useMemo } from "react";
import { getAssignedLaunchForStudentById } from "./api";
import { Link, useLocation } from "react-router-dom";
import ArrowBackOutlinedIcon from "@mui/icons-material/ArrowBackOutlined";
import {
  Box,
  Divider,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  Toolbar,
  Typography,
} from "@mui/material";
import getCookie, { setStudentCookie, studentState } from "../../Atom";
import Breadcrumb from "../Breadcrumb/Breadcrumb";
import CanvasJSReact from "../../../assets/js/canvasjs-commercial-3.4/canvasjs.react";
import Paper from "@mui/material/Paper";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import CircularProgress from "@mui/material/CircularProgress";

export default function LauchtrekDetail(props) {
  const location = useLocation();
  const data = location.state;
  const [launchtrak, setLaunchtrak] = useState([]);
  const [csvDataFile, setCsvDataFile] = useState([]);
  const [myUser, setmyUser] = useState(studentState);
  const [loading, setLoading] = useState(false);
  var CanvasJSChart = CanvasJSReact.CanvasJSChart;
  const [acceleration, setAcceleration] = useState([]);
  const [hGAcc, setHGAcc] = useState([]);
  const [graphs, setGraphs] = useState("acc");
  const [accx, setAccx] = useState([]);
  const [accy, setAccy] = useState([]);
  const [accz, setAccz] = useState([]);
  const [hgx, setHgx] = useState([]);
  const [hgy, setHgy] = useState([]);
  const [hgz, setHgz] = useState([]);
  const [press, setPress] = useState([]);
  const [height, setHeight] = useState([]);
  const [visibleDatasets, setVisibleDatasets] = useState({
    x: false,
    y: false,
    z: false,
  });
  const [visibleGraphs, setVisibleGraphs] = useState({
    acc: true,
    height: false,
    hGAcc: false,
  });
  const [subVisibleGraphs, setSubVisibleGraphs] = useState({
    acc: true,
    height: false,
    hGAcc: false,
  });
  const breadcrumbs = [
    <Link
      underline="hover"
      key="1"
      style={{ display: "flex", alignItems: "center", gap: 8 }}
      to={`/launchtrak`}
    >
      <ArrowBackOutlinedIcon style={{ color: "#000000" }} />
      <Typography style={{ color: "#00000080" }}> LaunchTrak Files</Typography>
    </Link>,
    <Typography
      key="2"
      variant="h1"
      color="#252926"
      style={{ fontWeight: 500, fontSize: 21, fontFamily: "Inter" }}
    >
      {data?.fileName}
    </Typography>,
  ];
  const logoutHandler = async () => {
    setTimeout(() => {
      // setmyUser({
      //   fName: null,
      //   userId: null,
      //   token: null,
      //   lName: null,
      // })

      setStudentCookie({
        fName: null,
        userId: null,
        token: null,
        lName: null,
      });

      let hostname = window.location.host;
      ////console.loghostname,window.location.protocol)
      window.location.assign(`${window.location.protocol}//${hostname}/`);
    });
  };
  const convertArrayToCSV = (arrayOfObjects) => {
    if (!arrayOfObjects || !arrayOfObjects.length) {
      return "";
    }
    // Mapping for header replacements
    const headerReplacements = {
      time: "Time(us)",
      roll: "Roll(deg)",
      pitch: "Pitch(deg)",
      yaw: "Yaw(deg)",
      ax: "AccX(m/s/s)",
      ay: "AccY(m/s/s)",
      az: "AccZ(m/s/s)",
      press: "Press(Pa)",
      temp: "Temp(C)",
      hgx: "HGX(g)",
      hgy: "HGY(g)",
      hgz: "HGZ(g)",
    };

    const excludeHeaders = ["acc", "vel", "altitude", "highGAcceleration"];
    const headers = Object.keys(arrayOfObjects[0])
      .filter((header) => !excludeHeaders.includes(header))
      .map((header) => headerReplacements[header] || header);

    const rows = arrayOfObjects.map((obj) =>
      headers
        .map((headerKey) => {
          // Get the original key from headerReplacements or use the header itself
          const originalKey =
            Object.keys(headerReplacements).find(
              (key) => headerReplacements[key] === headerKey
            ) || headerKey;
          return `"${obj[originalKey] ?? ""}"`;
        })
        .join(",")
    );
    const csvData = [headers.join(","), ...rows].join("\n");
    setCsvDataFile(csvData);
  };
  function formatValueWithUnit(value) {
    if (!value) return "--";

    const numericValue = parseFloat(value);
    const unitMatch = value.match(/\(([^)]+)\)/);

    const formattedValue = isNaN(numericValue) ? "--" : numericValue.toFixed(2);
    const unit = unitMatch ? unitMatch[0] : "";

    return `${formattedValue} ${unit}`;
  }
  const handleChange = (e) => {
    const v = e.target.value;
    setGraphs(v);
    setVisibleGraphs({
      acc: v === "acc" ? true : false,
      height: v === "alti" ? true : false,
      hGAcc: v === "highGAcc" ? true : false,
    });
    setVisibleDatasets({
      x: false,
      y: false,
      z: false,
    });
    setSubVisibleGraphs({
      acc: v === "acc" ? true : false,
      height: v === "alti" ? true : false,
      hGAcc: v === "highGAcc" ? true : false,
    });
  };
  const downloadCSV = () => {
    // Create a blob and a download link
    const blob = new Blob([csvDataFile], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `${data?.fileName}.csv`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };
  const getListOflaunchtrakById = async (id, user = myUser) => {
    setLoading(true);

    let res;
    res = await getAssignedLaunchForStudentById(user?.token, id);
    if (res?.error) {
      if (res?.data?.status == 401) {
        logoutHandler();
      }
    } else if (res?.res?.status == 200) {
      console.log("res..///", res);
      let acc = [];
      let height = [];
      let hGAcc = [];
      let ax = [];
      let ay = [];
      let az = [];
      let hgx = [];
      let hgy = [];
      let hgz = [];
      let press = [];
      const response = res?.res?.data?.graphData[0]?.graphData;
      for (let i = 0; i < response?.length; i++) {
        acc.push({
          x: response[i]?.time,
          y: response[i]?.acc,
        });
        ax.push({
          x: response[i]?.time,
          y: response[i]?.ax,
        });
        ay.push({
          x: response[i]?.time,
          y: response[i]?.ay,
        });
        az.push({
          x: response[i]?.time,
          y: response[i]?.az,
        });
        height.push({
          x: response[i].time,
          y: response[i].altitude,
        });
        press.push({
          x: response[i].time,
          y: response[i].press,
        });
        hgx.push({
          x: response[i]?.time,
          y: response[i]?.hgx,
        });
        hgy.push({
          x: response[i]?.time,
          y: response[i]?.hgy,
        });
        hgz.push({
          x: response[i]?.time,
          y: response[i]?.hgz,
        });
        hGAcc.push({
          x: response[i].time,
          y: response[i].highGAcceleration,
        });
      }
      acc.sort((a, b) => a.x - b.x);
      setAcceleration(acc);
      height.sort((a, b) => a.x - b.x);
      setHeight(height);
      hGAcc.sort((a, b) => a.x - b.x);
      setHGAcc(hGAcc);
      setLaunchtrak(res?.res?.data?.fileData[0]);
      ax.sort((a, b) => a.x - b.x);
      setAccx(ax);
      ay.sort((a, b) => a.x - b.x);
      setAccy(ay);
      az.sort((a, b) => a.x - b.x);
      setAccz(az);
      press.sort((a, b) => a.x - b.x);
      setPress(press);
      hgx.sort((a, b) => a.x - b.x);
      setHgx(hgx);
      hgy.sort((a, b) => a.x - b.x);
      setHgy(hgy);
      hgz.sort((a, b) => a.x - b.x);
      setHgz(hgz);
      convertArrayToCSV(response);
    }
    setLoading(false);
  };
  const toggleDatasetVisibility = (key) => {
    setVisibleDatasets((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };
  const chartOptions = {
    animationEnabled: false,
    exportEnabled: true,
    theme: "light1",
    height: "600",
    title: {
      text: (() => {
        if (visibleGraphs.acc) return "Acceleration";

        if (visibleGraphs.height) {
            const altitudeSelected = subVisibleGraphs.height;
            const pressureSelected = visibleDatasets.x;  

            if (altitudeSelected && pressureSelected) {
                return "Altitude & Pressure";
            } else if (altitudeSelected) {
                return "Altitude";
            } else if (pressureSelected) {
                return "Pressure";
            } else {
                return "Altitude"; 
            }
        }

        if (visibleGraphs.hGAcc) return "High G Acceleration";

        return "";
    })(),
      fontFamily: "Inter",
      fontSize: 21,
      fontWeight: 500,
      color: "#000000",
      padding: 4,
    },
    axisX: {
      title: "Time (S)",
      suffix: "",
      gridThickness: 1,
      gridColor: "#dbdbdb",
      titleFontSize: 22,
      labelFontSize: 12,
    },
    axisY: {
      title: visibleGraphs.acc
        ? "Accel (m/s^2)"
        : visibleGraphs.height && subVisibleGraphs.height
        ? "Altitude (m)"
        : visibleGraphs.hGAcc
        ? "Accel (g)"
        : "",
      titleFontFamily: "Inter",
      titleFontWeight: 400,
      gridThickness: 1,
      gridColor: "#dbdbdb",
      titleFontSize: 22,
      labelFontSize: 12,
    },
    axisY2: {
      title: visibleGraphs.height && visibleDatasets.x ? "Pressure (Pa)" : "",
      titleFontFamily: "Inter",
      titleFontWeight: 400,
      gridThickness: 1,
      gridColor: "#dbdbdb",
      titleFontSize: 22,
      labelFontSize: 12,
    },
    data: [
      {
        type: "spline",
        toolTipContent: `{x} sec: {y}  ${
          visibleGraphs.acc
            ? "m/s^2"
            : visibleGraphs.height
            ? "pa"
            : visibleGraphs.hGAcc
            ? "g"
            : []
        }`,
        dataPoints: visibleGraphs.acc
          ? accx
          : visibleGraphs.height
          ? press
          : visibleGraphs.hGAcc
          ? hgx
          : [],
        visible: visibleDatasets.x, // Dynamically controlled visibility
        name: visibleGraphs.acc
          ? "x"
          : visibleGraphs.height
          ? "pressure"
          : visibleGraphs.hGAcc
          ? "x"
          : "",
        axisYType: visibleGraphs.height ? "secondary" : "primary",
      },
      {
        type: "spline",
        toolTipContent: `{x} sec: {y} ${
          visibleGraphs.acc
            ? "m/s^2"
            : visibleGraphs.height
            ? ""
            : visibleGraphs.hGAcc
            ? "g"
            : ""
        }`,
        dataPoints: visibleGraphs.acc
          ? accy
          : visibleGraphs.height
          ? []
          : visibleGraphs.hGAcc
          ? hgy
          : [],
        visible: visibleDatasets.y, // Dynamically controlled visibility
        name: "y",
      },
      {
        type: "spline",
        toolTipContent: `{x} sec: {y} ${
          visibleGraphs.acc
            ? "m/s^2"
            : visibleGraphs.height
            ? ""
            : visibleGraphs.hGAcc
            ? "g"
            : ""
        }`,
        dataPoints: visibleGraphs.acc
          ? accz
          : visibleGraphs.height
          ? []
          : visibleGraphs.hGAcc
          ? hgz
          : [],
        visible: visibleDatasets.z, // Dynamically controlled visibility
        name: "z",
      },
      {
        type: "spline",
        toolTipContent: "{x} sec: {y} m/s^2",
        dataPoints: acceleration,
        visible: visibleGraphs.acc
          ? subVisibleGraphs.acc
            ? true
            : false
          : false,
        name: "acceleration",
      },
      {
        type: "spline",
        toolTipContent: "{x} sec: {y} m",
        dataPoints: height,
        visible: visibleGraphs.height
          ? subVisibleGraphs.height
            ? true
            : false
          : false,
        name: "height",
      },
      {
        type: "spline",
        toolTipContent: "{x} sec: {y} g",
        dataPoints: hGAcc,
        visible: visibleGraphs.hGAcc
          ? subVisibleGraphs.hGAcc
            ? true
            : false
          : false,
        name: "hGAcc",
      },
    ],
  };

  const chartKey = useMemo(() => Date.now(), [chartOptions]);

  useEffect(() => {
    const _cookie = getCookie("recoil-persist");
    if (!_cookie) {
      logoutHandler();
    } else {
      props.page("launchtrak");
      const user = JSON.parse(_cookie)["student"];
      setmyUser(user);
      getListOflaunchtrakById(data?.id);
    }
  }, []);
  return (
    <main style={{ position: "absolute", width: "100%", top: "10%" }}>
      <div
        className="container px-4 pt-3"
        style={{ display: "flex", flexDirection: "column", gap: 20 }}
      >
        <div className="lower-section px-60 pt-3 pb-5 mt-3 mx-1">
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center", // Vertically align content
              justifyContent: "space-between", // Space out Breadcrumb and Toolbar
              gap: "16px", // Optional: Adjust spacing between components
            }}
          >
            <Breadcrumb breadcrumbs={breadcrumbs} />
            {/* Toolbar Component */}
            <Toolbar
              title="download graph csv"
              style={{ display: "flex", alignItems: "center", gap: "8px" }}
            >
              <IconButton onClick={downloadCSV} style={{ padding: 0 }}>
                <FileDownloadIcon sx={{ color: "#7f2490" }} />
              </IconButton>
            </Toolbar>
          </div>
          <Divider />
          {loading ? (
            <Paper
              sx={{
                height: "100%",
                mb: 2,
                backgroundColor: "transparent",
                border: "none",
                boxShadow: "none",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <CircularProgress />
            </Paper>
          ) : (
            <div className="mt-3">
              <Box display="flex" justifyContent="space-between">
                <div
                  style={{ display: "flex", flexDirection: "column", gap: 30 }}
                >
                  <div
                    style={{ display: "flex", flexDirection: "column", gap: 5 }}
                  >
                    <Typography
                      sx={{
                        fontWeight: 500,
                        fontSize: 22,
                        fontFamily: "Inter",
                      }}
                    >
                      Value of interest
                    </Typography>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        gap: 10,
                        flexWrap: "wrap",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          gap: 2,
                        }}
                      >
                        {console.log("launchtrak///", launchtrak)}
                        <Typography
                          sx={{
                            fontWeight: 500,
                            fontSize: 16,
                            fontFamily: "Inter",
                          }}
                        >
                          Decent speed :{" "}
                        </Typography>
                        <span>
                          {launchtrak?.valuesOfInterest?.["Descent Speed"]
                            ? formatValueWithUnit(
                                launchtrak?.valuesOfInterest?.["Descent Speed"]
                              )
                            : "--"}
                        </span>
                      </div>{" "}
                      <hr sx={{ height: 20 }} />
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          gap: 2,
                        }}
                      >
                        <Typography
                          sx={{
                            fontWeight: 500,
                            fontSize: 16,
                            fontFamily: "Inter",
                          }}
                        >
                          Top speed :{" "}
                        </Typography>
                        <span>
                          {launchtrak?.valuesOfInterest?.["Max Speed"]
                            ? formatValueWithUnit(
                                launchtrak?.valuesOfInterest?.["Max Speed"]
                              )
                            : "--"}
                        </span>
                      </div>{" "}
                      <hr />
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          gap: 2,
                        }}
                      >
                        <Typography
                          sx={{
                            fontWeight: 500,
                            fontSize: 16,
                            fontFamily: "Inter",
                          }}
                        >
                          Total flight time :
                        </Typography>
                        <span>
                          {launchtrak?.valuesOfInterest?.["Flight Time"]
                            ? formatValueWithUnit(
                                launchtrak?.valuesOfInterest?.["Flight Time"]
                              )
                            : "--"}
                        </span>
                      </div>{" "}
                      <hr />
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          gap: 2,
                        }}
                      >
                        <Typography
                          sx={{
                            fontWeight: 500,
                            fontSize: 16,
                            fontFamily: "Inter",
                          }}
                        >
                          Apogee altitude :{" "}
                        </Typography>
                        <span>
                          {launchtrak?.valuesOfInterest?.["Apogee"]
                            ? formatValueWithUnit(
                                launchtrak?.valuesOfInterest?.["Apogee"]
                              )
                            : "--"}
                        </span>
                      </div>{" "}
                      <hr />
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          gap: 2,
                        }}
                      >
                        <Typography
                          sx={{
                            fontWeight: 500,
                            fontSize: 16,
                            fontFamily: "Inter",
                          }}
                        >
                          Apogee time :
                        </Typography>
                        <span>
                          {launchtrak?.valuesOfInterest?.["Apogee Time"]
                            ? formatValueWithUnit(
                                launchtrak?.valuesOfInterest?.["Apogee Time"]
                              )
                            : "--"}
                        </span>
                      </div>{" "}
                      <hr />
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          gap: 2,
                        }}
                      >
                        <Typography
                          sx={{
                            fontWeight: 500,
                            fontSize: 16,
                            fontFamily: "Inter",
                          }}
                        >
                          Coast time :{" "}
                        </Typography>
                        <span>
                          {launchtrak?.valuesOfInterest?.["coastTime"]
                            ? formatValueWithUnit(
                                launchtrak?.valuesOfInterest?.["coastTime"]
                              )
                            : "--"}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <Box display="flex" flexDirection="column" gap={1}>
                  {/* DROP DOWN TO SELECT GRAPH DATA */}
                  <FormControl sx={{ minWidth: 120 }} size="small">
                    <InputLabel id="demo-select-small-label">
                      Graph's
                    </InputLabel>
                    <Select
                      labelId="demo-select-small-label"
                      id="demo-select-small"
                      value={graphs}
                      label="Graph's"
                      onChange={handleChange}
                    >
                      <MenuItem value="acc">Acceleration</MenuItem>
                      <MenuItem value="alti">Altitude</MenuItem>
                      <MenuItem value="highGAcc">High G Acceleration</MenuItem>
                    </Select>
                  </FormControl>
                  <Box display="flex" gap={1} marginBottom={-2}>
                    <label>
                      <input
                        type="checkbox"
                        checked={visibleDatasets.x}
                        onChange={() => toggleDatasetVisibility("x")}
                        style={{ marginRight: "6px" }}
                      />
                      {visibleGraphs.height ? "Pressure" : "x-axis"}
                    </label>
                    {!visibleGraphs.height && (
                      <label>
                        <input
                          type="checkbox"
                          checked={visibleDatasets.y}
                          onChange={() => toggleDatasetVisibility("y")}
                          style={{ marginRight: "6px" }}
                        />
                        y-axis
                      </label>
                    )}
                    {!visibleGraphs.height && (
                      <label>
                        <input
                          type="checkbox"
                          checked={visibleDatasets.z}
                          onChange={() => toggleDatasetVisibility("z")}
                          style={{ marginRight: "6px" }}
                        />
                        z-axis
                      </label>
                    )}
                  </Box>
                  <label>
                    <input
                      type="checkbox"
                      checked={
                        (visibleGraphs.acc && subVisibleGraphs.acc) ||
                        (visibleGraphs.height && subVisibleGraphs.height) ||
                        (visibleGraphs.hGAcc && subVisibleGraphs.hGAcc)
                      }
                      onChange={() =>
                        setSubVisibleGraphs({
                          acc: !subVisibleGraphs.acc,
                          height: !subVisibleGraphs.height,
                          hGAcc: !subVisibleGraphs.hGAcc,
                        })
                      }
                      style={{ marginRight: "6px" }}
                    />
                      {visibleGraphs.acc ? "Accel. Magnitude" : visibleGraphs.height ? "Altitude" : visibleGraphs.hGAcc ? "High G Magnitude" : ""}

                  </label>
                </Box>
              </Box>
              <Divider />
              {/* GRAPH DATA SECTION */}
              <div className="d-flex flex-wrap justify-content-between align-items-start mt-2">
                <CanvasJSChart key={chartKey} options={chartOptions} />
              </div>
            </div>
          )}
        </div>
      </div>
    </main>
  );
}
